import { baseTheme } from 'primsell-shared-layer/styles/theme'
import * as S from './loader.styles'

export enum LoaderColorE {
  VIOLET,
  DARK,
  WHITE,
}

export enum LoaderVariantE {
  PRIMARY,
  SECONDARY,
}

export interface ILoaderConfigItem {
  primaryColor: string
  secondaryColor: string
}

export interface ILoaderProps {
  color?: LoaderColorE
  variant?: LoaderVariantE
}

export const loaderColorConfig: Record<LoaderColorE, ILoaderConfigItem> = {
  [LoaderColorE.VIOLET]: {
    primaryColor: '#BE34FF',
    secondaryColor: '#5800B1',
  },
  [LoaderColorE.DARK]: {
    primaryColor: baseTheme.colors.grey,
    secondaryColor: baseTheme.colors.middleDark,
  },
  [LoaderColorE.WHITE]: {
    primaryColor: '#fff',
    secondaryColor: '#fff',
  },
}

export const loaderVariantConfig: Record<LoaderVariantE, React.FC<{ colors: ILoaderConfigItem }>> = {
  [LoaderVariantE.PRIMARY]: ({ colors }) => <S.Loader colors={colors} />,
  [LoaderVariantE.SECONDARY]: ({ colors }) => <S.LinearLoader colors={colors} />,
}

export const Loader = ({ color = LoaderColorE.VIOLET, variant = LoaderVariantE.PRIMARY }: ILoaderProps) => {
  return loaderVariantConfig[variant]({ colors: loaderColorConfig[color] })
}
